import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AsyncButton, extractAndFormatQuestions, formatQuestionDefaults, QuestionInputs, SaveStates } from '@infl-ts/ui-advocate-components';
import { useFocusErrors } from '@infl-ts/util-react-hook-form';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as NEA from 'fp-ts/NonEmptyArray';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var Questions = function Questions(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var questionForm = useForm({
    defaultValues: stage.questions ? formatQuestionDefaults(stage.questions) : undefined
  });
  useEffect(function () {
    questionForm.reset(stage.questions ? formatQuestionDefaults(stage.questions) : undefined);
  }, [stage.id, stage.questions]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);

  var _useFocusErrors = useFocusErrors(),
      questionRef = _useFocusErrors.questionRef,
      focusOnFirstError = _useFocusErrors.focusOnFirstError;

  return /*#__PURE__*/_jsx(StageLayout, {
    showPublicResponseMessage: true,
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      status: mutationValue,
      text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next'],
      onClick: questionForm.handleSubmit(function (data) {
        return completeStage({
          questionsInput: _objectSpread({
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id
          }, !!stage.questions && A.isNonEmpty(stage.questions) ? {
            responses: extractAndFormatQuestions(Object.entries(data), pipe(stage.questions, NEA.groupBy(function (q) {
              return q.id;
            })))
          } : {})
        });
      }, focusOnFirstError)
    }),
    "data-element": "StageLayout",
    "data-component": "Questions",
    "data-source-file": "index.tsx",
    children: stage.questions && /*#__PURE__*/_jsx(QuestionInputs, {
      questionRef: questionRef,
      questions: stage.questions,
      questionForm: questionForm
    })
  });
};

export default Questions;